import React, { useState } from 'react';
import { Formik, Form } from 'formik';

import { UTILITY_TYPE_ID_INTERNET } from 'common/utility/constants';

import {
  SR_API_ACTION_UTILITY_ACTIVATION_UPDATE,
  SR_API_ACTION_UTILITY_ACTIVATION_UPDATE_ITEM,
} from 'api/utilityActionTypes';

import { createFormValidationFn } from 'client/helpers/formikHelpers';

import requestUtilityApi from 'client/actions/requestUtilityApi';

import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';
import SrButton, { SR_BUTTON_THEME_ADOBE_YELLOW } from 'client/components/SrButton/SrButton';
import { formFields as tenantFormFields } from 'client/components/SrUtilityProfitAdminProcessActivationPage/SrUtilityProfitAdminProcessActivationForm'; // eslint-disable-line max-len

import './UPOrdersHitlistTable.less';

const UPOrderHitlistInternetItemForm = ({
  dispatch,
  utilityActivation,
  utilityDealers,
  reloadUtilityActivation,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const item = utilityActivation.items.find(({ utilityTypeId }) => utilityTypeId === 1);

  const updateActivation = (payload) => {
    setIsSubmitting(true);
    return dispatch(requestUtilityApi, {
      action: SR_API_ACTION_UTILITY_ACTIVATION_UPDATE,
      payload,
      onError(error) {
        setIsSubmitting(false);
        global.alert(error.message);
      },
      onSuccess() {
        setIsSubmitting(false);
      },
    }).then(reloadUtilityActivation);
  };

  const updateActivationItem = (payload) => {
    setIsSubmitting(true);
    return dispatch(requestUtilityApi, {
      action: SR_API_ACTION_UTILITY_ACTIVATION_UPDATE_ITEM,
      payload,
      onError(error) {
        setIsSubmitting(false);
        global.alert(error.message);
      },
      onSuccess() {
        setIsSubmitting(false);
      },
    }).then(reloadUtilityActivation);
  };

  const [hasAccountIdByUtilityTypeId, setHasAccountIdByUtilityTypeId] = useState(
    utilityActivation.items.reduce((acc, item) => {
      if (item.type.id === UTILITY_TYPE_ID_INTERNET) {
        acc[item.utilityTypeId] = true;
        return acc;
      }

      acc[item.utilityTypeId] = !!item.accountNumber || !item.proofOfPurchaseUrl;
      return acc;
    }, {}),
  );

  const hasAccountId = hasAccountIdByUtilityTypeId[item.type.id];

  const tenantFormInitialState = tenantFormFields.tenant.initialState({
    item,
    utilitySalesRepId: utilityActivation.utilitySalesRepId,
  });

  const getTenantFormFields = (formValues) =>
    tenantFormFields.tenant.fields({
      item,
      formValues,
      utilityProvidersList: [],
      utilityDealers,
      utilitySalesReps: [],
      hasAccountIdByUtilityTypeId,
      setHasAccountIdByUtilityTypeId,
      hideUtilitySalesRepId: true,
    });

  const onTenantFormSubmit = tenantFormFields.tenant.onSubmit({
    item,
    utilitySalesRepId: utilityActivation.utilitySalesRepId,
    updateActivation,
    updateActivationItem,
    hasAccountId,
  });

  return (
    <Formik
      initialValues={tenantFormInitialState}
      enableReinitialize
      onSubmit={onTenantFormSubmit}
      validate={(values) => {
        const formFields = getTenantFormFields(values);
        return createFormValidationFn(formFields)(values);
      }}
      render={(formikBag) => {
        const formFields = getTenantFormFields(formikBag.values);

        return (
          <Form styleName="internetItemForm">
            {formFields.map((formField) => (
              <SrFormikField
                key={formField.id}
                margin="13px 0 25px"
                formField={formField}
                formikBag={formikBag}
                theme={SR_FIELD_THEME_ADOBE}
              />
            ))}
            <SrButton
              theme={SR_BUTTON_THEME_ADOBE_YELLOW}
              disabled={!formikBag.isValid || !formikBag.dirty || isSubmitting}
              width="326px"
              margin="0 0 14px"
              hasBoxShadow
              type="submit"
            >
              Complete
            </SrButton>
          </Form>
        );
      }}
    />
  );
};

UPOrderHitlistInternetItemForm.displayName = 'UPOrderHitlistInternetItemForm';

export default UPOrderHitlistInternetItemForm;
